module.exports = __webpack_public_path__ + "static/img/feature_1.7e069f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/feature_1.png
// module id = B6I5
// module chunks = 0